import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import ErrorMessage from 'components/ErrorMessage';
import intl from 'react-intl-universal';

const UnsupportedMailBox = () => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <ErrorMessage middle={intl.get('unSupportedMailBoxMessage')} />
    </Box>
  );
};

export default UnsupportedMailBox;

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    display: 'flex',
    whiteSpace: 'break-spaces'
  }
}));
